import styled, { css } from 'styled-components'
import { fontSize } from '../../shared/styles/mixins'
import { SECONDARY } from '../../shared/styles/colors'
import { get } from 'lodash'

export default styled.div`
  font-weight: bold;
  margin: 24px auto;
  ${({ titleClass }) => css`${get(titleClass, 'banner', '')}`};
  ${({ titleClass }) => css`${get(titleClass, 'text', '')}`};
  .large {
    ${fontSize(80)}
    @media (max-width: 1024px) {
      ${fontSize(23)}
      ${({ titleClass }) => css`${get(titleClass, 'text', '')}`};
      text-align: center;
    }
    @media (max-width: 600px) {
      ${fontSize(30)}
      display: flex;
      justify-content: center;
      ${({ titleClass }) => css`${get(titleClass, 'large', '')}`};
      ${({ titleClass }) => css`${get(titleClass, 'text', '')}`};

      p {
        margin-right: 10px;
      }
    }
  }

  p {
    ${({ color }) =>
    color &&
    css`
        color: ${color};
      `}
  }
  .secondary {
    color: ${SECONDARY};
  }
`
